import Swiper from 'swiper/swiper-bundle'
export default {
  init() {
     
    //SLIDER WHITE PRODUCT

    const sliderWhite = document.querySelector('.product-white .swiper-container');
    if(sliderWhite){
      const sliderTeam = new Swiper(sliderWhite, {
        slidesPerView: '1.5',
        spaceBetween: 30,
        threshold : 10,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
         dragSize : 50
        },
        breakpoints : {
          520 : {
            slidesPerView : 2.1
          }
        }
      })
    }
      
  const sliderQuotes = document.querySelector('.product .swiper-container');
  if(sliderQuotes){
    const sliderTeam = new Swiper(sliderQuotes, {
      slidesPerView: '1.5',
      spaceBetween: 30,
      threshold : 10,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize : 50
      },
      breakpoints : {
        520 : {
          slidesPerView : 2.1
        }
      }
    })
  }
    
    let stickyNav = document.querySelector('.stickyNav');
    let anchor = stickyNav.querySelector('.anchor_price');
    if(anchor){
      
      let target = document.querySelector('.price_table');
  

      anchor.addEventListener('click', function(e){
        e.preventDefault();
        let targetBounds = target.getBoundingClientRect()
        window.scrollTo({
          behavior: 'smooth',
          top: targetBounds.top - document.body.getBoundingClientRect().top - 70
        })
      })
      
    }

 
     
   

    let popupActiv = false
    console.log('product')
    const dropDowns = document.querySelectorAll('.dropDown')

    function removeActive() {
      for (const dropDown of dropDowns) {
        dropDown.classList.remove('active')
      }
    }

    dropDowns.forEach((dropDown) => {
      dropDown.addEventListener('click', () => {
        // removeActive()
        if (!popupActiv) {
          dropDown.classList.toggle('active')
        }
      })
    })

    const navLink = document.querySelector('.nav-item button')
    if (navLink) {
      navLink.classList.add('active')
    }

    const firstTab = document.querySelector('.tab-pane')
    if (firstTab) {
      firstTab.classList.add('active', 'show')
    }

    const dropDownButtons = document.querySelectorAll('.dropDown .content span')

    const popupiLock = document.querySelector('.product__popupiLock')
    const crossIcon = document.querySelector('.product__popupiLock-cross')

    dropDownButtons.forEach((dropDownButton) => {
      dropDownButton.addEventListener('click', () => {
        popupiLock.classList.add('active')
        popupActiv = true
      })
    })

    crossIcon.addEventListener('click', () => {
      popupiLock.classList.remove('active')
      popupActiv = false
    })

    const tabPoints = document.querySelectorAll('.product_tab-point')
    const navLinks = document.querySelectorAll('.nav-link')
    const tabPanes = document.querySelectorAll('.tab-pane')
    function clearTabButtons() {
      for (const tabPoint of tabPoints) {
        tabPoint.classList.remove('active')
      }
    }

    function clearNavButtons() {
      for (const navLink of navLinks) {
        navLink.classList.remove('active')
      }
    }

    function clearTabPane() {
      for (const pane of tabPanes) {
        pane.classList.remove('show', 'active')
      }
    }
    navLinks.forEach((navLink) => {
      const tabAttribute = navLink.getAttribute('data-target')
      const pointButton = document.querySelector('.product_tab-point[data-name=' + tabAttribute, ']')

      navLink.addEventListener('click', () => {
        clearNavButtons()
        clearTabButtons()
        pointButton.classList.add('active')
        navLink.classList.add('active')
      })
    })

    tabPoints.forEach((tabPoint) => {
      const pointAttribute = tabPoint.getAttribute('data-name')
      const navButton = document.querySelector('.nav-link[data-target=' + pointAttribute, ']')
      const tabPane = document.querySelector('.tab-pane[data-target=' + pointAttribute, ']')
      tabPoint.addEventListener('click', () => {
        clearTabButtons()
        clearNavButtons()
        clearTabPane()

        tabPoint.classList.add('active')
        navButton.classList.add('active')
        tabPane.classList.add('active', 'show')

        const marginTop = window.innerHeight / 3
        const bounds = tabPane.getBoundingClientRect()

        window.scrollTo(0, bounds.top + document.documentElement.scrollTop - marginTop)
      })
    })

    const addToCartCta = document.querySelector('.add_to_cart_button')
    addToCartCta.addEventListener('click', () => {
      window.setTimeout(function () {
        window.location = '/cart-page'
      }, 100)
    })

    /// Responsive tabs

    const buttonLabel = document.querySelector('.projects_responsive-button-label')
    const navItem = document.querySelectorAll('.projects__nav-item')

    function displayItems() {
      for (const item of navItem) {
        item.style.display = 'block'
      }
    }
    buttonLabel.innerHTML = navItem[0].textContent

    navItem[0].style.display = 'none'

    tabPoints.forEach((point) => {
      point.addEventListener('click', () => {
        displayItems()
        const attribute = point.getAttribute('data-name')
        const dropDownLabel = document.querySelector('.projects__nav-item[data-target=' + attribute + ']')
        dropDownLabel.style.display = 'none'
        buttonLabel.innerHTML = dropDownLabel.textContent
      })
    })


  },
  finalize() {
    // JavaScript to be fired on the product page, after the init JS
  }
}
